import { createGetEndpoint } from '@sonar-software/sonar-http';
import { User } from '@types';

export const getCurrentUser = createGetEndpoint<void, User>('/api/v3/core/users/current');
